var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingCheckUncheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0753 22 22 17.0753 22 11C22 4.9247 17.0753 0 11 0C4.9247 0 0 4.9247 0 11C0 17.0753 4.9247 22 11 22Z",
    fill: "#A9CF3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02344 11.7122L8.86805 14.5568L15.9796 7.44531",
    stroke: "white",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingCheckUncheck);
export default __webpack_public_path__ + "static/media/pricing-check-uncheck.0a8fe65ae1bfc8fe0fd5cf1a46f7549d.svg";
export { ForwardRef as ReactComponent };